var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "widget_settings_tab" } }, [
    _c(
      "div",
      {
        staticClass: "mobile-widget-preview-show-btn",
        on: {
          click: function ($event) {
            return _vm.showMobileWidgetPreview()
          },
        },
      },
      [
        _c("span", [_vm._v(_vm._s(_vm.$t("widgetTab.previewBtn")))]),
        _c("i", { staticClass: "la la-angle-right" }),
      ]
    ),
    _c(
      "div",
      { staticClass: "bb-card widget-form-card" },
      [
        _c(
          "b-button",
          {
            directives: [
              {
                name: "b-toggle",
                rawName: "v-b-toggle.collapse-appearance",
                modifiers: { "collapse-appearance": true },
              },
            ],
            staticClass: "bb-colapse",
            on: {
              click: function ($event) {
                _vm.appearanceOpen != _vm.appearanceOpen
              },
            },
          },
          [
            _c("div", { staticClass: "collapse-btn-left" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "20",
                    height: "19",
                    viewBox: "0 0 20 19",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M5 12C3.34 12 2 13.34 2 15C2 16.31 0.84 17 0 17C0.92 18.22 2.49 19 4 19C6.21 19 8 17.21 8 15C8 13.34 6.66 12 5 12ZM18.71 2.63L17.37 1.29C16.98 0.899998 16.35 0.899998 15.96 1.29L7 10.25L9.75 13L18.71 4.04C19.1 3.65 19.1 3.02 18.71 2.63Z",
                      fill: "#1A73E8",
                    },
                  }),
                ]
              ),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("widgetTab.appearance.title"))),
              ]),
            ]),
            _c("i", { class: _vm.appearanceArrowClass }),
          ]
        ),
        _c(
          "b-collapse",
          {
            attrs: { id: "collapse-appearance" },
            model: {
              value: _vm.appearanceOpen,
              callback: function ($$v) {
                _vm.appearanceOpen = $$v
              },
              expression: "appearanceOpen",
            },
          },
          [
            _c("div", { staticClass: "bb-form-group inline-form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("widgetTab.appearance.logoInput.label"))),
              ]),
              _c("input", {
                ref: "logoInput",
                staticStyle: { display: "none" },
                attrs: { type: "file" },
                on: { change: _vm.onFileChange },
              }),
              !_vm.form.fields.logo && !_vm.form.helpers.logo
                ? _c(
                    "div",
                    {
                      staticClass: "widget-logo-placeholder",
                      on: {
                        click: function ($event) {
                          return _vm.uploadLogo()
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "24",
                            height: "26",
                            viewBox: "0 0 44 48",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M25.7059 7.21622H5.94118C4.63069 7.21622 3.37389 7.74015 2.44724 8.67277C1.52059 9.60538 1 10.8703 1 12.1892V37.0541M1 37.0541V42.027C1 43.3459 1.52059 44.6108 2.44724 45.5434C3.37389 46.4761 4.63069 47 5.94118 47H35.5882C36.8987 47 38.1555 46.4761 39.0822 45.5434C40.0088 44.6108 40.5294 43.3459 40.5294 42.027V32.0811M1 37.0541L12.3301 25.651C13.2567 24.7187 14.5133 24.195 15.8235 24.195C17.1338 24.195 18.3903 24.7187 19.3169 25.651L25.7059 32.0811M40.5294 19.027V32.0811M40.5294 32.0811L36.6111 28.1375C35.6844 27.2052 34.4279 26.6815 33.1176 26.6815C31.8074 26.6815 30.5508 27.2052 29.6242 28.1375L25.7059 32.0811M25.7059 32.0811L30.6471 37.0541M33.1176 5.97297H43M38.0588 1V10.9459M25.7059 17.1622H25.7306",
                              stroke: "#99ACC2",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("widgetTab.appearance.logoInput.description")
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.form.fields.logo || _vm.form.helpers.logo
                ? _c("img", {
                    staticClass: "widget-logo",
                    attrs: { src: _vm.logoPath },
                    on: {
                      click: function ($event) {
                        return _vm.uploadLogo()
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.errors.logo,
                    expression: "form.errors.logo",
                  },
                ],
                staticClass: "bb-invalid-feedback",
              },
              [_vm._v(" " + _vm._s(_vm.form.errors.logo) + " ")]
            ),
            _c("div", { staticClass: "bb-form-group inline-form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("widgetTab.appearance.colorInput.label"))),
              ]),
              _c(
                "div",
                { staticClass: "background-colors-container" },
                [
                  _vm._l(_vm.availableColors, function (color, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "bb-badge badge-rounded widget-color-badge",
                        style: "background: " + color + ";",
                        on: {
                          click: function ($event) {
                            return _vm.selectColor(color)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  color === _vm.form.fields.backgroundColor,
                                expression:
                                  "color === form.fields.backgroundColor",
                              },
                            ],
                            attrs: {
                              width: "18",
                              height: "14",
                              viewBox: "0 0 18 14",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M6.04965 13.2353C5.76596 13.2353 5.48227 13.1209 5.25532 12.8922L1.34043 8.94722C0.886525 8.48983 0.886525 7.80374 1.34043 7.34634C1.79433 6.88895 2.47518 6.88895 2.92908 7.34634L5.99291 10.4338L15.0709 1.34305C15.5248 0.885651 16.2057 0.885651 16.6596 1.34305C17.1135 1.80044 17.1135 2.48653 16.6596 2.94393L6.84397 12.8922C6.61702 13.1209 6.33333 13.2353 6.04965 13.2353Z",
                                fill: "white",
                                stroke: "white",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "bb-badge badge-rounded widget-color-badge add-new",
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-more-horizontal",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: { cx: "12", cy: "12", r: "1" },
                          }),
                          _c("circle", {
                            attrs: { cx: "19", cy: "12", r: "1" },
                          }),
                          _c("circle", {
                            attrs: { cx: "5", cy: "12", r: "1" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
                2
              ),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.errors.backgroundColor,
                    expression: "form.errors.backgroundColor",
                  },
                ],
                staticClass: "bb-invalid-feedback",
              },
              [_vm._v(" " + _vm._s(_vm.form.errors.backgroundColor) + " ")]
            ),
            _c("div", { staticClass: "bb-form-group inline-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("widgetTab.appearance.statusInput.label"))
                ),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.status,
                    expression: "form.fields.status",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "text" },
                domProps: { value: _vm.form.fields.status },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.fields, "status", $event.target.value)
                  },
                },
              }),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.errors.status,
                    expression: "form.errors.status",
                  },
                ],
                staticClass: "bb-invalid-feedback",
              },
              [_vm._v(" " + _vm._s(_vm.form.errors.status) + " ")]
            ),
            _c("div", { staticClass: "bb-form-group inline-form-group" }, [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("widgetTab.appearance.messageInput.label"))
                ),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.fields.message,
                    expression: "form.fields.message",
                  },
                ],
                staticClass: "bb-input",
                attrs: { type: "text" },
                domProps: { value: _vm.form.fields.message },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.fields, "message", $event.target.value)
                  },
                },
              }),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.errors.message,
                    expression: "form.errors.message",
                  },
                ],
                staticClass: "bb-invalid-feedback",
              },
              [_vm._v(" " + _vm._s(_vm.form.errors.message) + " ")]
            ),
            _c(
              "div",
              { staticClass: "bb-form-group inline-form-group" },
              [
                _c("BBSwitch", {
                  attrs: {
                    label: _vm.$t(
                      "widgetTab.appearance.showReviewsInput.label"
                    ),
                  },
                  model: {
                    value: _vm.form.fields.showReviews,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.fields, "showReviews", $$v)
                    },
                    expression: "form.fields.showReviews",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.errors.showReviews,
                    expression: "form.errors.showReviews",
                  },
                ],
                staticClass: "bb-invalid-feedback",
              },
              [_vm._v(" " + _vm._s(_vm.form.errors.showReviews) + " ")]
            ),
          ]
        ),
        _c(
          "b-button",
          {
            directives: [
              {
                name: "b-toggle",
                rawName: "v-b-toggle.collapse-installation",
                modifiers: { "collapse-installation": true },
              },
            ],
            staticClass: "bb-colapse",
            on: {
              click: function ($event) {
                _vm.installationOpen != _vm.installationOpen
              },
            },
          },
          [
            _c("div", { staticClass: "collapse-btn-left" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "20",
                    height: "10",
                    viewBox: "0 0 20 10",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M1.9 5C1.9 3.29 3.29 1.9 5 1.9H9V0H5C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10H9V8.1H5C3.29 8.1 1.9 6.71 1.9 5ZM6 6H14V4H6V6ZM15 0H11V1.9H15C16.71 1.9 18.1 3.29 18.1 5C18.1 6.71 16.71 8.1 15 8.1H11V10H15C17.76 10 20 7.76 20 5C20 2.24 17.76 0 15 0Z",
                      fill: "#1A73E8",
                    },
                  }),
                ]
              ),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("widgetTab.installation.title"))),
              ]),
              _c(
                "svg",
                {
                  staticClass: "feather feather-alert-octagon",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "#F6303A",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("polygon", {
                    attrs: {
                      points:
                        "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
                    },
                  }),
                  _c("line", {
                    attrs: { x1: "12", y1: "8", x2: "12", y2: "12" },
                  }),
                  _c("line", {
                    attrs: { x1: "12", y1: "16", x2: "12.01", y2: "16" },
                  }),
                ]
              ),
            ]),
            _c("i", { class: _vm.installationArrowClass }),
          ]
        ),
        _c(
          "b-collapse",
          {
            attrs: { id: "collapse-installation" },
            model: {
              value: _vm.installationOpen,
              callback: function ($$v) {
                _vm.installationOpen = $$v
              },
              expression: "installationOpen",
            },
          },
          [
            _c("p", [
              _vm._v(
                " " + _vm._s(_vm.$t("widgetTab.installation.description")) + " "
              ),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.widgetCodeString,
                  expression: "widgetCodeString",
                },
              ],
              attrs: { type: "hidden", id: "copy_input" },
              domProps: { value: _vm.widgetCodeString },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.widgetCodeString = $event.target.value
                },
              },
            }),
            _c("div", { staticClass: "installation-card-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "installation-card",
                  on: {
                    click: function ($event) {
                      _vm.jsInstructionsVisible = !_vm.jsInstructionsVisible
                    },
                  },
                },
                [
                  _c("div", [
                    _c(
                      "svg",
                      {
                        staticClass: "mr-2",
                        attrs: {
                          width: "11",
                          height: "20",
                          viewBox: "0 0 11 20",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M9.66638 2L1.66638 10L9.66638 18",
                            stroke: "#1A73E8",
                            "stroke-width": "2.28571",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "11",
                          height: "20",
                          viewBox: "0 0 11 20",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M1.33362 18L9.33362 10L1.33362 2",
                            stroke: "#1A73E8",
                            "stroke-width": "2.28571",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _c("span", [_vm._v("JavaScript")]),
                  _c("div", { staticClass: "placeholder" }),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.jsInstructionsVisible,
                      expression: "jsInstructionsVisible",
                    },
                  ],
                  staticClass: "installation-card-instructions",
                },
                [
                  _c("p", { staticClass: "instruction-text" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "widgetTab.installation.jsCard.instructions.step1"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "code-preview" }, [
                    _vm._v(" " + _vm._s(_vm.widgetCodeString) + " "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "installation-card-instructions-footer" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "bb-btn btn-success",
                          on: {
                            click: function ($event) {
                              return _vm.copyToClipboard()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("widgetTab.installation.jsCard.copyBtn")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "contact-us-section" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "feather feather-info",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "#1A73E8",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: { cx: "12", cy: "12", r: "10" },
                            }),
                            _c("line", {
                              attrs: { x1: "12", y1: "16", x2: "12", y2: "12" },
                            }),
                            _c("line", {
                              attrs: {
                                x1: "12",
                                y1: "8",
                                x2: "12.01",
                                y2: "8",
                              },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "need-help" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "widgetTab.installation.jsCard.needHelpLabel"
                              )
                            )
                          ),
                        ]),
                        _c("span", { staticClass: "contact-us" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "widgetTab.installation.jsCard.contactUsLabel"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "installation-card-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "installation-card",
                  on: {
                    click: function ($event) {
                      _vm.wpInstructionsVisible = !_vm.wpInstructionsVisible
                    },
                  },
                },
                [
                  _c("div", [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "32",
                          height: "32",
                          viewBox: "0 0 32 32",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M2.2655 16.0001C2.2655 21.4332 5.4106 26.1285 9.97125 28.3535L3.44924 10.4139C2.6906 12.121 2.2655 14.0101 2.2655 16.0001ZM25.1681 15.3074C25.1681 13.611 24.5612 12.4362 24.0406 11.5218C23.3475 10.3912 22.6979 9.43366 22.6979 8.303C22.6979 7.04123 23.6511 5.86669 24.9938 5.86669C25.0544 5.86669 25.1119 5.87426 25.171 5.87766C22.7385 3.64037 19.4976 2.27438 15.9381 2.27438C11.1615 2.27438 6.95909 4.73472 4.51434 8.46128C4.83512 8.47094 5.13743 8.47773 5.39421 8.47773C6.82433 8.47773 9.03805 8.30352 9.03805 8.30352C9.77509 8.25991 9.86198 9.34669 9.12572 9.43419C9.12572 9.43419 8.38504 9.52168 7.56085 9.56504L12.5398 24.4329L15.532 15.4239L13.4018 9.56452C12.6655 9.52116 11.968 9.43366 11.968 9.43366C11.2312 9.39031 11.3176 8.25938 12.0544 8.303C12.0544 8.303 14.3123 8.47721 15.6558 8.47721C17.0857 8.47721 19.2996 8.303 19.2996 8.303C20.0372 8.25938 20.1238 9.34617 19.3873 9.43366C19.3873 9.43366 18.6451 9.52116 17.8224 9.56452L22.7634 24.3198L24.1272 19.7446C24.7183 17.8461 25.1681 16.4825 25.1681 15.3074ZM16.178 17.2007L12.0757 29.1679C13.3006 29.5293 14.5959 29.727 15.9381 29.727C17.5303 29.727 19.0572 29.4507 20.4784 28.949C20.4418 28.8902 20.4085 28.8278 20.3811 28.7599L16.178 17.2007ZM27.9352 9.4146C27.994 9.85182 28.0273 10.3212 28.0273 10.826C28.0273 12.2189 27.7682 13.7847 26.9877 15.7425L22.8113 27.8648C26.8761 25.4852 29.6101 21.0641 29.6101 16.0003C29.6104 13.6139 29.0032 11.3698 27.9352 9.4146ZM15.9381 0C7.15005 0 0 7.17757 0 16.0001C0 24.8236 7.15005 32.0009 15.9381 32.0009C24.7259 32.0009 31.8769 24.8236 31.8769 16.0001C31.8767 7.17757 24.7259 0 15.9381 0ZM15.9381 31.2675C7.55304 31.2675 0.730797 24.4185 0.730797 16.0001C0.730797 7.58214 7.55278 0.733663 15.9381 0.733663C24.3229 0.733663 31.1446 7.58214 31.1446 16.0001C31.1446 24.4185 24.3229 31.2675 15.9381 31.2675Z",
                            fill: "#464342",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _c("span", [_vm._v("WordPress")]),
                  _c("div", { staticClass: "placeholder" }),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.wpInstructionsVisible,
                      expression: "wpInstructionsVisible",
                    },
                  ],
                  staticClass: "installation-card-instructions",
                },
                [
                  _c("p", { staticClass: "instruction-text" }, [
                    _vm._v(
                      " 1. " +
                        _vm._s(
                          _vm.$t(
                            "widgetTab.installation.wpCard.instructions.step1"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c("p", { staticClass: "instruction-text" }, [
                    _vm._v(
                      " 2. " +
                        _vm._s(
                          _vm.$t(
                            "widgetTab.installation.wpCard.instructions.step2"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c("p", { staticClass: "instruction-text" }, [
                    _vm._v(
                      " 3. " +
                        _vm._s(
                          _vm.$t(
                            "widgetTab.installation.wpCard.instructions.step3"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c("p", { staticClass: "instruction-text" }, [
                    _vm._v(
                      " 4. " +
                        _vm._s(
                          _vm.$t(
                            "widgetTab.installation.wpCard.instructions.step4"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c("p", { staticClass: "instruction-text" }, [
                    _vm._v(
                      " 5. " +
                        _vm._s(
                          _vm.$t(
                            "widgetTab.installation.wpCard.instructions.step5"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "code-preview" }, [
                    _vm._v(" " + _vm._s(_vm.widgetCodeString) + " "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "installation-card-instructions-footer" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "bb-btn btn-success",
                          on: {
                            click: function ($event) {
                              return _vm.copyToClipboard()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("widgetTab.installation.wpCard.copyBtn")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "contact-us-section" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "feather feather-info",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "#1A73E8",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: { cx: "12", cy: "12", r: "10" },
                            }),
                            _c("line", {
                              attrs: { x1: "12", y1: "16", x2: "12", y2: "12" },
                            }),
                            _c("line", {
                              attrs: {
                                x1: "12",
                                y1: "8",
                                x2: "12.01",
                                y2: "8",
                              },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "need-help" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "widgetTab.installation.wpCard.needHelpLabel"
                              )
                            )
                          ),
                        ]),
                        _c("span", { staticClass: "contact-us" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "widgetTab.installation.wpCard.contactUsLabel"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
        _c("div", { staticClass: "widget-form-card-footer" }, [
          _c(
            "button",
            {
              staticClass: "bb-btn btn-success",
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("widgetTab.saveBtn")) + " ")]
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.widgetPreviewVisible,
            expression: "widgetPreviewVisible",
          },
        ],
        staticClass: "widget-preview-wrapper",
      },
      [
        _c("div", { staticClass: "widget-preview" }, [
          _c(
            "div",
            {
              staticClass: "mobile-widget-preview-hide-btn",
              on: {
                click: function ($event) {
                  return _vm.hideMobileWidgetPreview()
                },
              },
            },
            [
              _c("i", { staticClass: "la la-angle-left" }),
              _c("span", [_vm._v(_vm._s(_vm.$t("widgetTab.backBtn")))]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "top-section",
              style: "background:" + _vm.form.fields.backgroundColor + ";",
            },
            [
              _c("img", { attrs: { src: _vm.logoPath } }),
              _c("h2", [_vm._v(_vm._s(_vm.form.fields.status))]),
              _c("span", [_vm._v(_vm._s(_vm.form.fields.message))]),
            ]
          ),
          _c("div", { staticClass: "bottom-section" }),
          _c("div", { staticClass: "start-booking-section" }, [
            _c("span", { staticClass: "section-title" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("widgetTab.widget.startBookingLabel"))
              ),
            ]),
            _c("div", { staticClass: "next-free-time-example" }, [
              _c("div", { staticClass: "badges-container" }, [
                _c(
                  "div",
                  { staticClass: "bb-badge badge-rounded background-badge" },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-user",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "#99ACC2",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2",
                          },
                        }),
                        _c("circle", { attrs: { cx: "12", cy: "7", r: "4" } }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "bb-badge badge-rounded front-badge" },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-user",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "#99ACC2",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2",
                          },
                        }),
                        _c("circle", { attrs: { cx: "12", cy: "7", r: "4" } }),
                      ]
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "next-free-time-text-container" }, [
                _c("span", { staticClass: "next-free-time-label" }, [
                  _vm._v(_vm._s(_vm.$t("widgetTab.widget.nextFreeTimeLabel"))),
                ]),
                _c("div", { staticClass: "next-free-time-time-container" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "feather feather-clock",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "#1A73E8",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                      _c("polyline", { attrs: { points: "12 6 12 12 16 14" } }),
                    ]
                  ),
                  _c("span", [_vm._v(_vm._s(_vm.nextFreeTimeString))]),
                ]),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "book-btn",
                style: "background:" + _vm.form.fields.backgroundColor + ";",
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("widgetTab.widget.bookingBtn"))),
                ]),
                _c("i", { staticClass: "la la-angle-right" }),
              ]
            ),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.fields.showReviews,
                  expression: "form.fields.showReviews",
                },
              ],
              staticClass: "reviews-section",
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("widgetTab.widget.reviewsLabel")) + " "),
              ]),
              _c("i", { staticClass: "la la-angle-down" }),
            ]
          ),
          _c("div", { staticClass: "footer-section" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("widgetTab.widget.poweredByLabel"))),
            ]),
            _c("img", { attrs: { src: _vm.widgetFooterLogoPath } }),
          ]),
        ]),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.mobileWidgetPreviewVisible,
            expression: "!mobileWidgetPreviewVisible",
          },
        ],
        staticClass: "mobile-submit-btn-footer",
      },
      [
        _c(
          "button",
          {
            on: {
              click: function ($event) {
                return _vm.submit()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("widgetTab.saveBtn")))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }